import { render } from "./HeaderShopping.vue?vue&type=template&id=dc27e5c2"
import script from "./HeaderShopping.vue?vue&type=script&lang=js"
export * from "./HeaderShopping.vue?vue&type=script&lang=js"

import "./HeaderShopping.vue?vue&type=style&index=0&id=dc27e5c2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__